import React from "react";
import { Helmet } from "react-helmet";
import ContactBody from "../components/contact/ContactBody";
import PageHero from "../components/reusables/hero/PageHero";

export default function Contact() {
  return (
    <>
      <Helmet>
        <link
          rel="conanical"
          href="https://www.negash.co/contact-us"
        />
        <meta
          name="description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          property="og:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta property="og:title" content="Contact Us - Negash Construction Company" />
        <meta
          property="og:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />

        <meta name="twitter:title" content="Contact Us - Negash Construction Company" />
        <meta
          name="twitter:text:title"
          content="Contact Us - Negash Construction Company"
        />
        <meta
          name="twitter:description"
          content="Negash Construction Company is a leading South Sudan firm with 25+ years of experience in civil, structural, and building works."
        />
        <meta
          name="twitter:image"
          content="https://res.cloudinary.com/malidad/image/upload/v1708492028/jmstonebanner_hoycxz.jpg"
        />
        <title>Contact Us - Negash Construction Company</title>
      </Helmet>
      <PageHero
        classes="doggy-bg"
        titleClasses="title uppercase white text-shadow"
        title="Contact Us &amp; Map"
      />
      <ContactBody />
    </>
  );
}
